import {
    REGIONAL_RESTRICTION_LIST,
    REGIONAL_RESTRICTION_STORE_LIST,
    REGIONAL_RESTRICTION_ITEMS_LIST,
    REGIONAL_RESTRICTION_ADD,
    REGIONAL_RESTRICTION_CATEGORIES,
    REGIONAL_RESTRICTION_TYPES,
    REGIONAL_RESTRICTION_GROUPS,
    REGIONAL_RESTRICTION_MANUFACTURERS,
    REGIONAL_RESTRICTION_ITEMS_BY_STORE,
    REGIONAL_RESTRICTION_BY_ITEM_ID,
    REGIONAL_RESTRICTION_ITEM_LIST,
} from "../types";

export const getRegionalRestrictionsListAction = (data, onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const getRegionalRestrictionsItemListAction = (data, onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_ITEM_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const getStoreListAction = (onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_STORE_LIST,
        onSuccess,
        onError,
    };
};

export const getItemsListAction = (data, onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_ITEMS_LIST,
        data,
        onSuccess,
        onError,
    };
};

export const addRegionalRestrictionAction = (data, onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_ADD,
        data,
        onSuccess,
        onError,
    };
};

// Dropdown filter actions
export const getCategoriesAction = (onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_CATEGORIES,
        onSuccess,
        onError,
    };
};

export const getItemTypesAction = (onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_TYPES,
        onSuccess,
        onError,
    };
};

export const getItemGroupsAction = (onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_GROUPS,
        onSuccess,
        onError,
    };
};

export const getManufacturersAction = (onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_MANUFACTURERS,
        onSuccess,
        onError,
    };
};

// Sub-table actions
export const getItemsByStoreIdAction = (storeId, onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_ITEMS_BY_STORE,
        storeId,
        onSuccess,
        onError,
    };
};

export const getRestrictionByItemIdAction = (itemId, storeId, onSuccess, onError) => {
    return {
        type: REGIONAL_RESTRICTION_BY_ITEM_ID,
        itemId,
        storeId,
        onSuccess,
        onError,
    };
};
